/** API route map: URLS.Controller.Paystub */
export const Paystub = {
      Name: 'Paystub/',
      GetAllPaystub: 'employee-paystubs',
      EmployeePayStubsTilesData: 'employee-paystubs-tiles-data',
      EmployeePayStubDetail: 'employee-paystub-detail',
      UploadPaystub: 'upload-paystub',
      EmployeePaystubPdf: 'employee-paystub-pdf',
      GetAllGarnishmentCheck: 'get-all-garnishment-check',
};
